import script from "./ButtonIcon.vue?vue&type=script&setup=true&lang=ts"
export * from "./ButtonIcon.vue?vue&type=script&setup=true&lang=ts"

import "./ButtonIcon.vue?vue&type=style&index=0&id=13ebb98b&lang=scss&scoped=true"

import exportComponent from "/fides/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-13ebb98b"]])

export default __exports__